<template>
  <div>
	 <b-toast
		id="toast-check-modal-recover-password"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-modal-recover-password"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-modal
         id="modal-recover-password" 
         :title="$t('title.2')"  
         :hide-body="true" 
         :centered="true" 
         no-close-on-backdrop 
         :no-close-on-esc="true"
          @hide="handleHideModal">
            <template #modal-header="{ close }">
                    <img class="close" src="@/assets/img/close_red.png" @click="close()">
                  
                    <div v-if="nextStep" style="text-align: -webkit-center;" >
                        <header>
                            <h6 class="sub-title"><span>{{langLocal=='es' ? 'Recupera tu Contraseña': 'Recover your password'}}</span></h6>
                        </header>
                        <p v-if="this.$store.state.is_teacher" class="mt-4">We have sent an email to: <b>{{user.email}}</b> 
                            Please use the link in the email to restore your password.
                        </p>
                        <p v-else class="mt-4">Te hemos enviado un correo a: <b>{{user.email}}</b> 
                            Por favor usar el link en el correo electrónico para restaurar tu contraseña.
                        </p>
                    </div>
                    <div v-else>
                        <header>
                            <h6 class="sub-title"><span>{{langLocal=='es' ? 'Recuperar Contraseña': 'Recover Password'}}</span></h6>
                        </header>
                        <b-form-group class="mt-4">
                            <p>{{langLocal=='es' ? 'Correo Electrónico': 'Email'}}</p>
                            <b-form-input v-model.trim="user.email"
                                v-bind:class="{ error: $v.user.email.$error}" @blur="$v.user.email.$touch()"
                            >
                            </b-form-input>
                            <span class="error-input">{{ validationMsgLogin($v.user.email)}}</span>
                        </b-form-group>
                    </div>
                 
            
            </template>

                
            <template #modal-footer>
                <div v-if="nextStep">
                      <b-button variant="primary" @click="$bvModal.hide('modal-recover-password');$v.$reset()">OK</b-button>
                </div>
                <div v-else style="display: flex;">
                    <b-button variant="danger" class="mr-3" @click="$bvModal.hide('modal-recover-password');$v.$reset()">{{langLocal=='es' ? 'Cancelar': 'Cancel'}}</b-button>
                    <b-button @click="validateEmail" variant="primary" :class="{ loading: showSpinnerSave }">
                        {{langLocal=='es' ? 'Confirmar': 'Confirm'}}
                    </b-button>
                    </div>
               
            </template>
	    </b-modal>
	
</div>
   
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { required, email } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';

const formMessagesLogin = {
    required: function () {
        return this.$t('validations.formMessagesLogin.required')
    },
    email: function () {
        return this.$t('validations.formMessagesLogin.email')
    }
}
export default {
	name:"modalRecoverPassword",
	data() {
		return {
            nextStep : false,
            showSpinnerSave:false,
            message:'',
            user:{
                email:'',
                ProfileId:''
            },
            langLocal: 'es'
		}
	},
    validations: {
        user:{
            email: {
                required,
                email
            },
        }
            
    },
	props:{

	},
	created() {
	    window.location.pathname.split('/')[1] === 'teacher' ? this.langLocal='en' : this.langLocal='es'
	},
	methods: {
        handleHideModal(){
            this.nextStep = false,
            this.showSpinnerSave=false,
            this.message='',
            this.user={
                email:'',
                ProfileId:''
            }
        },
        validationMsgLogin: validationMessage(formMessagesLogin),
        validateEmail(){
            
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }else{
                this.showSpinnerSave = true;
                baseInstanceAxios
                    .post(`${this.apiURL}/resources/Persons/ValidateRecoveryEmail `, this.user)
                    .then(response => {
                    
                        this.nextStep = false;
                        if(response.data.value == 0){
                            this.message = this.$t('reusables.email-not-valid');
                            this.$bvToast.show("toast-equis-modal-recover-password");
                        }

                        if(response.data.value == 1){
                            this.message = this.$t('reusables.user-not-active');
                            this.$bvToast.show("toast-equis-modal-recover-password");

                        }

                        if(response.data.value == 2){
                            this.message = this.langLocal=='es' ? 'Se envió correctamente': 'The email was sent correctly.';
                            this.$bvToast.show("toast-check-modal-recover-password");
                            this.nextStep = true;
                        }
                        this.showSpinnerSave  = false;
                    })
                    .catch(error => {
                        this.message = this.$t('my-cours.mesage-system-error');
                        this.$bvToast.show("toast-equis-modal-recover-password");
                        this.showSpinnerSave = false;
                    });
                    
            }
            
        },
        getShowModal(type){
            this.$bvModal.show('modal-recover-password')
            this.user.ProfileId = type
        }
	}

}
</script>